import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=a47c5640&scoped=true&"
import script from "./Swiper.vue?vue&type=script&lang=js&"
export * from "./Swiper.vue?vue&type=script&lang=js&"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=a47c5640&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47c5640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a47c5640')) {
      api.createRecord('a47c5640', component.options)
    } else {
      api.reload('a47c5640', component.options)
    }
    module.hot.accept("./Swiper.vue?vue&type=template&id=a47c5640&scoped=true&", function () {
      api.rerender('a47c5640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/news/comp/Swiper.vue"
export default component.exports